class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');

    // With a mouse the menus also open on hover (Elias, 2026-10-21); click and keyboard work as before
    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
      this.addEventListener('mouseleave', this.onMouseLeave.bind(this));
      this.mainDetailsToggle.querySelector('summary').addEventListener('click', this.onSummaryClick.bind(this));
    }
  }

  onMouseEnter() {
    clearTimeout(this.hoverTimer);
    document.querySelectorAll('header-menu').forEach((menu) => {
      if (menu !== this && menu.mainDetailsToggle.open) menu.close();
    });
    if (this.mainDetailsToggle.open) return;
    const summary = this.mainDetailsToggle.querySelector('summary');
    this.mainDetailsToggle.setAttribute('open', '');
    summary.setAttribute('aria-expanded', true);
    // The panel starts below the info row: bridge the gap so the pointer can travel down to it
    const gap = this.content.getBoundingClientRect().top - summary.getBoundingClientRect().bottom;
    summary.style.setProperty('--hover-bridge', `${Math.max(0, Math.ceil(gap))}px`);
  }

  onMouseLeave() {
    clearTimeout(this.hoverTimer);
    this.hoverTimer = setTimeout(() => this.close(), 200);
  }

  onSummaryClick(event) {
    // A mouse click on an open menu under the pointer would only fold it shut again
    if (event.detail > 0 && this.mainDetailsToggle.open && this.matches(':hover')) event.preventDefault();
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
